import React, { Component } from 'react';
import '../css/ticketRef.css'
import $ from "jquery";
import { CURRENCY, FORMAT_NUMBER } from '../libs/utils/Const';
function BarCode({ folioBarcode }) {
    return <img alt="" />;
}

class RefMoveCashModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeAction = () => {
        const { cashMovementModel, RefreshCashMovementModel, newOrderModel, ShowRefMoveCashModal, howRefMoveCashModal, AddPay, action, valueOption, openEntryMovement } = this.props;
        $('#refMoveCashModal').on('hidden.bs.modal', function () {

            cashMovementModel.cashAmount = '';
            cashMovementModel.comment = '';
            cashMovementModel.type = '';
            RefreshCashMovementModel(cashMovementModel);
            if (action !== 'inventory' && valueOption !== 2) {
                newOrderModel.MoneyMovements = [];
                newOrderModel.TotalMoneyMovement = 0.00;
            }
            AddPay()
            newOrderModel.ObjType = 'deliveries';
            if (action === 'inventory') {
                openEntryMovement();
            }
        });

    };

    render() {
        const { PrintCashMovements, cashMovementModel, _user, newOrderModel } = this.props

        let data = {
            amount: newOrderModel.MoneyMovements && (Array.isArray(newOrderModel.MoneyMovements) && newOrderModel.MoneyMovements.length) ? newOrderModel.MoneyMovements[0].Amount : '',
            descrip: cashMovementModel ? cashMovementModel.comment : '',
            type: cashMovementModel ? cashMovementModel.type === 1 ? "in" : "out" : ''
        }

        return (
            <div className="modal fade" id="refMoveCashModal" role="dialog" tabIndex="-1" aria-labelledby="refMoveCashModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content" style={{ backgroundColor: "#fff0", border: "none" }}>
                        <div className="modal-body">
                            <div className="ticketRef" style={{ fontSize: 12 }}>
                                <div className="m-3">
                                    <div className="" >
                                        <div className="text-center" >
                                            <img className="img-fluid d-block mx-auto" src={require('../images/logoTicket.png')} style={{ maxWidth: "200px" }} alt="COUNTER ONE"></img>
                                            <p>{`SUCURSAL: ${_user?.Sucursal.toUpperCase()} `}</p>
                                            <p>{_user?.Branch.Address.toUpperCase()}</p>
                                            <br />
                                            <h6><strong>{(data.type === "in" ? "ENTRADA CON " : "SALIDA CON ") + (newOrderModel.MoneyMovements.length > 0 ? newOrderModel.MoneyMovements[0].PM_Name : "").toUpperCase()}</strong></h6>
                                            <p>{data.descrip || ""}</p>
                                        </div>
                                    </div>

                                    <div className="text-center ">
                                        <div className="pr-2 pl-2">
                                            <h3><strong>{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(data.amount || "0"))}</strong></h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-right" style={{ marginTop: "50px" }}>
                                    <button className="btn" onClick={() => PrintCashMovements((data.type === "in" ? "ChashIn" : "ChashOut"), "80", cashMovementModel)}>
                                        <i className="fa fa-print" aria-hidden="true" style={{ fontSize: "25px", color: "#80808073" }}></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RefMoveCashModal;